// extracted by mini-css-extract-plugin
export default {"page":"KvRu3pwUdwRVZ8g9Q9D3","pageHeader":"xlvThF2cN0NI9TZ63FcE","tableContainer":"LOXsX6LjZ4i06jweonA7"};